
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.387 23.282a3.99 3.99 0 014-3.981h.736v-.732a3.977 3.977 0 012.961-3.828 16.693 16.693 0 00-3.839-1.289 6.874 6.874 0 10-7.827 0C2.572 15.156 2.116 19.47 2 22.043a1.4 1.4 0 00.917 1.344c1.351.355 4.081.847 11.414.847h.176a4.131 4.131 0 01-.12-.952z"}}),_c('path',{attrs:{"d":"M27.881 21.295h-2.745v-2.726a2.005 2.005 0 00-4.01 0v2.726h-2.745a1.993 1.993 0 100 3.986h2.746v2.725a2.005 2.005 0 004.01 0v-2.725h2.744a1.994 1.994 0 100-3.987z"}})])
          )
        }
      }
    